import { render, staticRenderFns } from "./ModalGroupCategoryProductTypeEdit.vue?vue&type=template&id=7cf8f44c&scoped=true"
import script from "./ModalGroupCategoryProductTypeEdit.vue?vue&type=script&lang=js"
export * from "./ModalGroupCategoryProductTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalGroupCategoryProductTypeEdit.vue?vue&type=style&index=0&id=7cf8f44c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf8f44c",
  null
  
)

export default component.exports